
const appParameters = window.apparguments || {};

export function GetParameter(name) {
	return appParameters[name];
}

export function WebApi(url, data, onSuccess, onError) {
	let method = 'GET';
	if (data != null) {
		method = 'POST';
		try {
			data = JSON.stringify(data);
		} catch (ex) {
			console.error(ex);
			return;
		}
	}
	const xhr = new XMLHttpRequest();
	xhr.onreadystatechange = () => {
		if (xhr.readyState === 4) {
			const contentType = xhr.getResponseHeader('Content-Type');
			const err = { status: xhr.status, statusText: xhr.statusText, message: 'error', code: 0, url: url };
			const response = xhr.responseText;
			if (xhr.status === 200) {
				let resp;
				let ok = false;
				if (contentType && contentType.indexOf('application/json') >= 0) {
					try {
						resp = JSON.parse(response);
						ok = true;
					} catch (ex) {
						err.message = ex.message;
						console.error(ex);
					}
				} else {
					resp = response;
					ok = true;
				}
				if (ok) {
					if (onSuccess) {
						try {
							onSuccess(resp);
						} catch (ex) {
							console.error(ex);
						}
					}
					return; // Ok
				}
			}
			if (onError) {
				if (contentType && contentType.indexOf("application/json") >= 0) {
					try {
						let resp = JSON.parse(response);
						if (resp.code) {
							err.code = resp.code;
						}
						if (resp.message) {
							err.message = resp.message;
						}
					} catch (ex) {
						err.message = ex.message;
						console.error(ex);
					}
				}
				try {
					onError(err);
				} catch (ex) {
					console.error(ex);
				}
			}
		}
	};
	xhr.open(method, url, true);
	if (method === 'POST') { xhr.setRequestHeader('Content-Type', 'application/json'); }
	xhr.setRequestHeader('Cache-Control', 'no-store');
	xhr.setRequestHeader('Authorization', 'Bearer ' + GetParameter('access_token'));
	xhr.send(data);
}

let rights = [];

export function LoadRights(url, done) {
	WebApi(url, null, (response) => {
		if (response && response.rights) {
			rights = response.rights;
		}
		if (done) done(null);
	}, (err) => {
		if (done) done(err);
	});
}

export function CheckRight(name) {
	return rights.indexOf(name) >= 0;
}
